var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"banner"}},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.titulo}})])}
var staticRenderFns = []

export { render, staticRenderFns }